import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IDrop } from '../../types/reducerTypes'

export type DropSlice = {
  drop: IDrop | undefined
}

const initialState: DropSlice = {
  drop: undefined,
}

export const drop = createSlice({
  name: 'drop',
  initialState,
  reducers: {
    setDrop: (state, { payload }: PayloadAction<IDrop>) => {
      state.drop = payload
      return state
    },
  },
})

export const { setDrop } = drop.actions

export default drop.reducer
